import {IDateRangeGState} from "../../interfaces/datesGlobalState.interface";
import {Action} from "@leap4/frontend";
import {ActionsTypes} from "../consts/actionsTypes"
import moment from "moment";
import {DATE_FORMAT, DAYS, OptionalDays} from "../../config/generals";
import {urlService} from "../../components/routing/urlsService"

const url: URL = new URL(window.location.href);
const params: URLSearchParams = url.searchParams;
const defaultComparison = DAYS.ONE.value
const sd = params.get("startDate") || moment().subtract(0, "days").format(DATE_FORMAT);
const ed = params.get("endDate") || moment().subtract(0, "days").format(DATE_FORMAT);
const comparison = +params.get("comparison") as OptionalDays || defaultComparison;

if (!window.location.pathname.includes('/login')) {
    window.history.replaceState(null, null, window.location.pathname);
}

const initialState: IDateRangeGState = {
    startDate: sd,
    endDate: ed,
    isLoading: {
        isLoadingGeneral: false,
        isLoadingGraph: false,
        isLoadingTopDiscTagsTable: false,
        isLoadingAdServers: false,
        isLoadingPartners: false,
        isLoadingTopTags: false,
        isLoadingTopPartnersCombos: false
    },
    isLoadingAny: false,
    selectedComparison: comparison
};

urlService.startDate = sd
urlService.endDate = ed
urlService.comparison = comparison

function isLoadingAny(obj: any) {
    const values = Object.values(obj)

    return values.some(x => !!x)
}

export const DateRangeReducer = function (state: IDateRangeGState = initialState, action: Action) {

    const {type, payload} = action;
    switch (type) {

        case ActionsTypes.SET_TIME_RANGE:
            urlService.startDate = payload.startDate
            urlService.endDate = payload.endDate
            return {
                ...state,
                startDate: payload.startDate,
                endDate: payload.endDate,
            };
        case  ActionsTypes.SET_COMPARISON_DATE:
            urlService.comparison = payload;
            return {
                ...state,
                selectedComparison: payload
            }
        case ActionsTypes.SET_IS_LOADING:
            const obj = {
                ...state.isLoading,
                ...payload.isLoading,
            }
            return {
                ...state,
                isLoading: obj,
                isLoadingAny: isLoadingAny(obj)
            }
        default:
            return state;
    }
}
